import { Crown, Gift } from "lucide-react";

/**
 * VipBadge — displayed next to VIP usernames.
 * variants: sm (inline), md (card), lg (profile hero)
 */
export default function VipBadge({ user, size = "sm" }) {
  if (!user?.is_vip) return null;

  const isLifetime = user.vip_tier === "lifetime" || user.vip_expires_at === null;
  const isGifted = !!user.vip_gifted_by;

  const styles = {
    sm: "text-[9px] px-1.5 py-0.5 gap-1",
    md: "text-[10px] px-2 py-1 gap-1.5",
    lg: "text-xs px-3 py-1.5 gap-2",
  };
  const iconSize = { sm: "w-2.5 h-2.5", md: "w-3 h-3", lg: "w-3.5 h-3.5" };

  return (
    <span
      data-testid="vip-badge"
      title={`${isLifetime ? "Lifetime Ascended" : "Ascended"}${isGifted ? ` · gifted by @${user.vip_gifted_by}` : ""}`}
      className={`inline-flex items-center ${styles[size]} font-mono uppercase tracking-widest font-bold bg-gradient-to-r from-[#00ff7a] to-[#7affbc] text-black border border-[var(--primary)] shrink-0`}
      style={{ boxShadow: "0 0 10px rgba(0, 255, 122, 0.55)" }}
    >
      {isGifted ? <Gift className={iconSize[size]} strokeWidth={2.5} /> : <Crown className={iconSize[size]} strokeWidth={2.5} />}
      <span>{isLifetime ? "ASCENDED ∞" : "ASCENDED"}</span>
    </span>
  );
}
